/* eslint-disable react/no-typos */
import React from 'react'
import PropTypes from 'prop-types';
import { Rating } from 'react-simple-star-rating';
export default function RattingPage(props) {
  if(props?.ratingValue >=0){
    return(
      <Rating
        {...props}
        onClick={props?.onClick}
        initialValue={props?.initialValue}
        readonly={props?.readonly}
        size={props?.size}
        fillColor={"var(--pr-color)"}
      />
    )
  }
  return props?.initialValue > 0 && (
    <Rating
        {...props}
        initialValue={props?.initialValue}
        readonly={props?.readonly}
        size={props?.size}
        fillColor={"var(--pr-color)"}
    />
  )
}
RattingPage.propTypes = {
    fillColor: PropTypes.any,
    size: PropTypes.any,
    initialValue: PropTypes.any,
    readonly: PropTypes.any,
}